import { DEV_MODE } from "@constants";

import React from "react";

import { useCard, useSocketConnection, useSteps } from "@hooks/.";
import useElectronPreload from "@hooks/useElectronPreload";

import { TimeoutLogic } from "@components/IdleDetection";
import { AuthenticationModalWrapper } from "@components/LocalSettings/AuthenticationModalWrapper";
import { LocalConfigModalWrapper } from "@components/LocalSettings/LocalConfigModalWrapper";
import { TechnicalProblemModal } from "@components/TechnicalProblemModal";

import { LogoutProblemModal } from "@pages/Kiosk/LogoutProblemModal";
import { LoyaltyWrapper } from "@pages/Kiosk/Loyalty";
import { StepComponent } from "@pages/Kiosk/Steps/StepComponent";
import { UserAccountModalWrapper } from "@pages/Kiosk/UserAccountModalWrapper";

import { HelpModalWrapper } from "../HelpModalWrapper";
import "./transitions.css";

export function Steps(): JSX.Element {
    useSteps();
    useCard();
    useSocketConnection();
    useElectronPreload();

    return (
        <React.Fragment>
            <AuthenticationModalWrapper />
            <LocalConfigModalWrapper />
            {process.env.REACT_APP_MODE !== DEV_MODE ? <TimeoutLogic /> : null}
            <HelpModalWrapper />
            <UserAccountModalWrapper />
            <TechnicalProblemModal />
            <LogoutProblemModal />
            <LoyaltyWrapper />
            <StepComponent />
        </React.Fragment>
    );
}
